/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react';
import { jsx, css } from '@emotion/react';
import { useFormikContext } from "formik";
import { Label } from '@fluentui/react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TextField from '../../../Forms/TextField';
import BasicInfoStep from '../../../Forms/Steps/BasicInfoStep';
import FluentSelect from '../../../Forms/FluentSelect';
import TextCKEditor from '../../../Forms/TextCKEditor';
import Toggle from '../../../Forms/Toggle';
import ImageUploadStep from '../../../Forms/Steps/ImageUploadStep';
import { getRequiredLabel } from '../../../Util/getRequiredLabel';
import { basicInfoFields, getBannerOptions, helpContainerCss } from '../Helpers/CopyAndFunctions';

const BasicInfoFields = ({ qnsData, openEndedQnsData }) => {
  const { values, setFieldValue } = useFormikContext();
  const [showHelp, setShowHelp] = useState(false);
  const bannerOptions = getBannerOptions(values);
  const isPublished = values.publishStatus === 'Published';
  const toQnsOption = q => ({ value: q.key, label: `${q.key} - ${q.value}` });
  
  return (
    <>
      <BasicInfoStep fields={basicInfoFields} />
      <div css={css`padding-bottom: 30px;`}>
        <ImageUploadStep options={bannerOptions} />
      </div>
      <TextField
            fullWidth
            label="Webinar Card Image"
            name="cardImageURL"
          />
          {values.cardImageURL && (
            <img src={values.cardImageURL} alt='Webinar Card' />)}
      <div css={helpContainerCss}>
        <div css={css`flex-grow: 1;`}>
          <TextField
            fullWidth
            label="Banner Alt Text"
            name="cardBannerAltText"
            required={isPublished}
          />
        </div>
        <HelpOutlineIcon
          onClick={() => setShowHelp(!showHelp)}
          style={{
            fontSize: 32,
            color: 'var(--Z8)',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        />
      </div>
      {showHelp && (<label className="preview-upload-help">Should describe the image for users with visual disabilities</label>)}
      <div css={css`padding-bottom: 30px;`}>
        <FluentSelect name='qnsId1' label={getRequiredLabel('Poll Question #1 (QNSID)', isPublished)} options={qnsData?.map(toQnsOption)} />
        <FluentSelect name='qnsId2' label={getRequiredLabel('Poll Question #2 (QNSID)', isPublished)} options={qnsData?.map(toQnsOption)} />
        <Toggle
          name='hasOpenEndedQuestion'
          label='Open-Ended Question'
          onText='Shown after the poll questions'
          offText='Not shown'
          css={css`margin-top: 20px;`}
        />
        {values.hasOpenEndedQuestion && (
          <FluentSelect name='openEndedQnsId' label={getRequiredLabel('Open-Ended Question (QNSID)', true)} options={openEndedQnsData?.map(toQnsOption)} />
        )}
      </div>
      <Label>{getRequiredLabel('About The Webinar', isPublished)} <span style={{ color: '#605e5c', fontWeight: 400, fontSize: 12 }}>(supports HTML formatting)</span></Label>
      <TextCKEditor 
        value={values.aboutText} 
        onChange={(val) => setFieldValue('aboutText', val)} 
      />
    </>
  );
};

export default BasicInfoFields;
